import { Helmet } from 'react-helmet';
import Header from '../../components/about/Header';
import Lines from '../../components/common/Lines';
import ProgressScroll from '../../components/common/ProgressScroll';
import Cursor from '../../components/common/cusor';
import Intro from '../../components/about/Intro';
import Intro2 from '../../components/about/Intro2';
import Navbar from '../../components/home-main/Navbar';
import Footer from '../../components/home-main/Footer';
import Marquee from '../../components/home-main/Marquee';
import Team from '../../components/home-main/Team';

export default function LPageAbout() {
  return (
    <>
      <Helmet>
        <title>GCAD</title>
        <link rel="icon" href="/light/assets/imgs/fox.png" />
        <link rel="shortcut icon" href="/light/assets/imgs/fox.png" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/plugins.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/style.css"
        />
        <script src="/light/assets/js/scripts.js"></script>
        <script src="/light/assets/js/smoother-script.js"></script>
      </Helmet>

      <div>
        <Cursor />
        <ProgressScroll />
        <Lines />
        <div id="smooth-wrapper">
          <Navbar />
          <div id="smooth-content">
            <main className="main-bg">
              <Header />
              <div className="padded-container">
                <Intro />
                <Marquee />
                <Intro2 />
                <Team />
              </div>
            </main>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}
